<template>
<div class="index" id="home" :style="{paddingTop: $store.state.headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true" :showNav="false"></SubHeader>
  
  <div class="index-vip" v-if="plat!=120 && !vipInfo.is_buy" v-show="false" @click="toVIP">
    <!-- 不是会员1 -->
    <div class="btn">
        开通会员
      </div>
  </div>
  <div class="index-vip2" v-else-if="plat != 120" v-show="false"  @click="toVIP">
    <!-- 是会员 -->
    <div class="content">
      <b>尊敬的会员用户</b>
      您的会员有效期到{{vipInfo.end_time}}
    </div>

      <div class="btn">
        立即续费
      </div>
  </div>
  <van-swipe class="my-swipe2" :autoplay="3000" indicator-color="black" :show-indicators="true" v-if="swiperData.length">
    <van-swipe-item v-for="item in swiperData" :key="item.id">
      <img :src="item.cover" @click="goDetail(item.url)"/>
    </van-swipe-item>
  </van-swipe>
  <!-- 职业认证 -->
  <div class="quality" v-if="jnLesson && jnLesson.list && jnLesson.list.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%8E%A8%E8%8D%90%402x.png"/>
      <div class="part-title_text">{{jnLesson.name}}</div>
      <p @click="toList(jnLesson.id)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="list12">
      <div v-for="(item, index) of jnLesson.list" :key="index" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
      </div>
    </div>
    <div class="line"></div>
  </div>
  <div class="level" v-if="yyList2.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <div class="part-title_text">{{yyList2Name}}</div>
      <p @click="toList(173)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
    </div>
      <div class="tabList">
          <p :class="{active:yyList2Index==index}" v-for="(item, index) in yyList2" :key="index" @click="yyList2Index = index">{{ item.name }}</p>
      </div>
      <PriceCard v-for="(v, i) of yyList2[yyList2Index].list[0].slice(0,3)"  :key="i"   @click.native="goDetail(v.id)" :index="yyList2Index" :cardData="v"></PriceCard>
  </div>
  
  <div class="level" v-if="yyList3.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <div class="part-title_text">{{yyList3Name}}</div>
      <p @click="toList(174)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
    </div>
    <div class="tabList">
          <p :class="{active:yyList3Index==index}" v-for="(item, index) in yyList3" :key="index" @click="yyList3Index = index">{{ item.name }}</p>
      </div>
      <PriceCard v-for="(v, i) of yyList3[yyList3Index].list[0].slice(0,3)"  :key="i"   @click.native="goDetail(v.id)" :index="yyList3Index" :cardData="v"></PriceCard>
  </div>
  <!-- 国培课 -->
  <div class="quality" v-if="gpLesson">
    <div class="part-titleYingyou part-title2" v-if="gpLesson">
      <div class="part-title_text">{{gpLesson.name}}</div>
    </div>
    <PriceCardImgBig :index="index" :cardData="item" v-for="(item, index) of gpLesson.list" :key="index"   @click.native="goDetail(item.id)" type="demonstrate"></PriceCardImgBig>
    <div class="line"></div>
  </div>
  <div class="part-titleYingyou part-title2" v-if="zqLesson">
    <div class="part-title_text">早期发展指导</div>
    <p @click="toList(zqLesson.id)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
  </div>
  <div class="sroll" v-if="zqLesson">
     <div class="srollItem" v-for="(item, i) of zqLesson.list"  :key="i" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)"></PriceCardjn>
     </div>
  </div>
  <!-- 托育管理指导 -->
  <div class="quality" v-if="tyLesson && tyLesson.list && tyLesson.list.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%8E%A8%E8%8D%90%402x.png"/>
      <div class="part-title_text">{{tyLesson.name}}</div>
      <p @click="toList(tyLesson.id)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="list12">
      <div v-for="(item, index) of tyLesson.list" :key="index" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
      </div>
    </div>
    <div class="line"></div>
  </div>
  
  <!-- 特训营 -->
  <div class="quality" v-if="txLesson">
    <div class="part-titleYingyou part-title2" v-if="txLesson">
      <div class="part-title_text">特训营</div>
      <p @click="toList(txLesson.id)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="quality-list">
      <PriceCard v-for="(item, index) of txLesson.list" :key="index" :index="index" :cardData="item" type="demonstrate"></PriceCard>
    </div>
    <div class="line"></div>
  </div>
  <div class="part-titleYingyou" v-if="ppLesson">
    <div class="part-title_text" >陪跑计划</div>
  </div>
  <PriceCardImgBig v-for="(item, i) of ppLesson"  :key="i" :index="index" :cardData="item"></PriceCardImgBig>
  <div class="quality"  v-if="jxLesson.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <div class="part-title_text">继续教育</div>
    </div>
    <div class="quality-list">
      <PriceCard v-for="(item, index) of jxLesson" :key="index" :index="index" :cardData="item" type="demonstrate"></PriceCard>
    </div>
    <div class="line"></div>
  </div>
  <!-- v-if="plat == 118 || plat == 119 || plat == 120" -->
  <div class="live" style="padding-bottom:20px" v-if="liveData.length">
    <div class="part-titleYingyou" v-if="!pageLoading">
      <div class="part-title_text">直播专栏</div>
      <div class="part-title_more" @click="goList('live')">查看更多></div>
    </div>
    <div class="hot-list">
      <LiveCard v-for="(item, index) of liveData" :key="index" :index="index" :cardData= "item"></LiveCard>
    </div>
  </div>
  <!-- <div class="live" style="padding-bottom:20px" >
    <div class="part-title" v-if="!pageLoading">
      <div class="part-title_text">锦囊</div>
      <div class="part-title_more" @click="goList('idea')">查看更多></div>
    </div>
    <div class="hot-list">
      <ideaList  :list="liveData[0].data"></ideaList>
    </div>
  </div> -->
  <div class="bottom">—   到底了…  —</div>
  <!-- <sub-footer :top="top" @toTop="toTop"></sub-footer> -->
  <img 
    class="topImg" v-if="top<0" @click="toTop"
    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%9B%9E%E5%88%B0%E9%A1%B6%E9%83%A8%402x.png"/>
</div>
</template>

<script>
import PriceCard from "@/components/PriceCardYingyou";
import PriceCardjn from "@/components/PriceCard1-3";
import PriceCardImgBig from "@/components/PriceCardImgBigYingyou";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeaderYingyou";
import SubFooter from "@/components/YingyouTab";
import LiveCard from "@/components/LiveCard";
import ideaList from "@/components/ideaList";
import { resolve } from "path";
import { Toast } from "vant";
import { timingSafeEqual } from "crypto";

// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: {
    PriceCard,
    PriceCardjn,
    VideoCard,
    TopCard,
    SubHeader,
    SubFooter,
    LiveCard,
    PriceCardImgBig,
    ideaList
  },
  computed: {
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    indexTab() {
      return this.$store.state.indexTab2;
    },
    indexData() {
      console.log("this.$store.state.plat", this.$store.state.plat);
      if (
        this.$store.state.plat_id == "119" ||
        this.$store.state.plat_id == "118"
      ) {
        return this.$store.state.plat.indexData;
      } else {
        let arr = this.menuData.map((e) => {
          return e;
        });
        arr.push({
          category_id: 0,
          category_name: "全部分类",
        });
        return arr;
      }
    },
  },
  data() {
    return {
      tabActive: "index",
      active: 0,
      pageLoading: true,
      listLoading: false,
      swiperData: [],
      category: [],
      gpLesson: [],
      jnLesson: [],
      jxLesson: [],
      liveData: [],
      vipInfo:{},
      zqLesson:null,
      tyLesson: null,
      ppLesson: null,
      gpLesson: null,
      txLesson: null,

      // 婴幼
      yyList2: [],
      yyList2Name: '',
      yyList2Index: 0,
      yyList3: [],
      yyList3Name: '',
      yyList3Index: 0,

      menuData: [],
      hotData: [],
      qualityData: [],
      topData: [],
      limit: 10,
      current: 0,
      certData: [],
      demonstrate:[],
      top:0,
    };
  },
  async mounted() {
    this.init();
    this.handleScrollToc()
    window.addEventListener("scroll", this.handleScrollToc, true);
  },
  beforeDestroy(){
    console.log('destory')
    window.removeEventListener("scroll", this.handleScrollToc, true);
  },
  methods: {
    toTop(){
      let timer = setInterval(()=>{
        document.documentElement.scrollTop = document.documentElement.scrollTop>=20 ? document.documentElement.scrollTop-20 : 0
        if(document.documentElement.scrollTop<=0){
          clearInterval(timer)
        }
      },10)
      
    },
    handleScrollToc() {
      let info = document.getElementById("home").getBoundingClientRect();
      this.top = info.top;

    },
    will() {
      this.$toast('敬请期待');
    },
    change(event) {
      this.current = event.detail.current;
    },
    
    async init() {
      if(this.$until.isWeiXin()=='wxapp'){
        await this.$request.mobileLogin({
               mobile:this.$route.query.phone
             })
      }
      let res = await this.$request.tuoyuIndex( {
          flat_id: this.plat,
          is_interior: 2,
          terminal: 1, //1 pc 2 小程序
        },);
      this.pageLoading = false;
      if (res.code == 0) {
        this.vipInfo = res.data.plat_vip
        this.$store.commit('SET_VIP', this.vipInfo)
        this.swiperData = res.data.banner || [];
        this.category = res.data.category_list || [];
        this.liveData = res.data.live_stream.map(item=>item.data).flat().slice(0,4)
        // 早期能力发展
        let zqLesson = this.category.find((item) => item.name == '早期能力发展');
        if(zqLesson){
          this.zqLesson = {
            id: zqLesson.id,
            name: zqLesson.name,
            list:zqLesson.list.map(item=>item.list[0]).flat().slice(0,3)
          }
        }
        // 职业能力认证
        let jnLesson = this.category.find((item) => item.id == '172');
        if(jnLesson){
          this.jnLesson = {
            id: jnLesson.id,
            name: jnLesson.name,
            list:jnLesson.list.map(item=>item.list[0]).flat().slice(0,4)
          }
        }
        //  托育管理指导 188
        let tyLesson = this.category.find((item) => item.name == '托育管理指导');
          if (tyLesson) {
            this.tyLesson = {
            id: tyLesson.id,
            name: tyLesson.name,
            list:tyLesson.list.map(item=>item.list[0]).flat().slice(0,4)
          }
        }
  
        let gpLesson = this.category.find((item) => item.id == 226);
          if (gpLesson) {
            this.gpLesson = {
            id: gpLesson.id,
            name: gpLesson.name,
            list:gpLesson.list.map(item=>item.list[0]).flat().slice(0,2)
          }
        }
        //  特训营
        let txLesson = this.category.find((item) => item.name == '特训营');
          if (txLesson) {
            this.txLesson = {
            id: txLesson.id,
            name: txLesson.name,
            list:txLesson.list.map(item=>item.list[0]).flat().slice(0,3)
          }
        }
        //  陪跑计划
        let ppLesson = this.category.find((item) => item.name == '陪跑计划');
          if (ppLesson) {
            this.ppLesson = {
            id: ppLesson.id,
            name: ppLesson.name,
            list:ppLesson.list.map(item=>item.list[0]).flat().slice(0,3)
          }
        }
        if (this.plat == 119) {
          //托育
          //  系统课 163
          this.vipLesson = this.category.find((item) => item.id == 163).list;

          // 职业技能认证122
          // let jnLesson = this.category.find((item) => item.id == 122);
          // if(jnLesson){
          //   this.jnLesson = {
          //     id: jnLesson.id,
          //     name: jnLesson.name,
          //     list:jnLesson.list.map(item=>item.list[0]).flat().slice(0,3)
          //   }
          //   console.log(jnLesson.list.map(item=>item.list[0]))
          // }

          // 国培课

        }else{
          //婴幼
          //  高级托育会员 173
          this.yyList2 = this.category.find((item) => item.id == 173).list;
          this.yyList2Name =  this.category.find((item) => item.id == 173).name;

          //  高级幼儿园会员 174
          this.yyList3 = this.category.find((item) => item.id == 174).list;
          this.yyList3Name = this.category.find((item) => item.id == 174).name;
          
        }
        
      } else {
        this.$toast(res.msg);
      }
    },
    jumpUser() {},
    async getUser() {
      let res = await this.$api({
        url: "/api/auth/me",
      });
      if (res.code == 0) {
        this.$store.commit("setUser", res.data);
      }
    },
    toPage(url){
      if(url) window.location.href = url
    },
    goDetail(id) {
      let url = `./detailYingyou?id=${id}`
     
      this.$router.push(url);
    },
    goLiveDetail(item) {
      let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
      } = item;
      let videoId = video_id;
      let type = 'aliyun'
      if (ccid) {
        id = ccid;
        type = 'cc';
      }
      if (video_url) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
      } else if(videoId){
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

      } else {
        this.$toast('没有视频')
      }

    },
    toList(id){
      this.$router.push(`./lessonYingyou?id=${id}`);
    },
    goList(type) {
      this.$router.push(`./${type}`);
    },
    goProductList(index) {
      if (this.plat == 118 || this.plat == 119) {
        this.will();
      } else {
        this.$router.push(`./lesson?index=${index}`);
      }
    },
    toVIP(){
      if(!localStorage.getItem('token')){
        this.$dialog.confirm({
          title: '提示',
          message: '请登录后查看',
          confirmButtonText:'立即登录',
        })
          .then(() => {
            // on confirm
            this.$router.push('./login/phone')
          })
          .catch(() => {
            // on cancel
          });
      }else{
        this.$router.push({
          path:'./vip/detailVIP',
          query:{
            id:this.vipInfo.goods_id
          }
        })
      }
    }
  },
};
</script>

<style lang="scss">
.topImg{
  position: fixed;
  z-index: 110;
  right: 50px;
  bottom: 50px;
  width: 80px;
  height: 80px;
}
  .my-swipe2{
    width: 690px;
    margin: 30px auto 0;
    img{
      width: 100%;
      border-radius: 10px;
    }
  }
  .index-vip {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/vip.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
 
  .index-vip2 {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/isVipBg.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
  .index-vip2 .content{
  position: absolute;
  left:30px;
  top:40px;
  color: #6a4a2c;
  font-size: 24px;
}
.index-vip2 .content b{
  display: block;
  font-weight: bold;
  font-size: 34px;
  margin-bottom: 15px;
}
.index-vip
 .btn, .index-vip2 .btn {
  position: absolute;
  bottom: 37px;
  right: 37px;
  width: 155px;
  height: 56px;
  background: #6a4a2c;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  font-size: 26px;
}
.index {
  min-height: 100vh;
  overflow: hidden;
  // padding-bottom: 2rem;
  background: #f9f9f9;
  padding-top: 100px;
  box-sizing: border-box;
}
.part-titleYingyou{
  display: flex;
  align-items: center;
  padding: 60px 30px 30px;
  >img{
    width: 36px;
    margin-right: 10px;
  }
  .part-title_text{
    flex: 1;
    font-weight: 500;
    color: #000000;
    font-size: 36px;
  }
  p{
    color: #999;
    font-size: 24px;
  }
}
.level{
  >b{
    font-size: 30px;
    padding: 0 0.4rem 0.2rem;
    display: block;
  }
}
.tabList{
  padding-top: 10px;
  padding-left: 30px;
  margin-bottom: 36px;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar{
    height: 0 !important;
  }
 -ms-overflow-style: none;
 overflow: -moz-scrollbars-none;
  p{
    display: inline-block;
    padding: 0 16px;
    border-radius: 24px;
    height: 48px;
    line-height: 48px;
    background: #fff;
    margin-right: 20px;
    font-size: 24px;
    color: #666;
    font-weight: 400;
  }
  p.active{
    background-color: #F08E00;
    color: #fff;
  }
  
}
.sroll{
  padding-left: 30px;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar{
    height: 0 !important;
  }
 -ms-overflow-style: none;
 overflow: -moz-scrollbars-none;
 .srollItem{
  display: inline-block;
  width: 70vw;
  margin-right: 20px;
 }
}
.quality {
  width: 100vw;

  .quality-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    .list13{
      flex: 1;
      margin-left: 20px;
      overflow: hidden;
      &:last-of-type{
        margin-right: 20px;
      }
    }
  }
  .list12{
    width: 100vw;
    padding: 0 30px;    
    >div{
      width: calc((100vw - 80px)*0.5);
      display: inline-block;
      &:nth-of-type(2n+1){
        margin-right: 20px;
      }
    }
  }
}
.bottom{
  font-size: 24px;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 34px;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

</style>
